import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import freeze from 'redux-freeze';
import _compact from 'lodash/compact';
import _get from 'lodash/get';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './rootReducer';
import { loadState } from './sessionStorage';
import { evaluateNonPersistableState } from './stateEvaluation';

const persistedState = loadState();

const environment = process.env.REACT_APP_ENVIRONMENT;

export default () => {
  /*
    If the call to rehydrate state from the sessionStorage happens when isLoading is set to true, we know the reload has happened during an API call.
    This means the UI will be out of step with the API and the history stack.
    In such a case the UI needs to realign itself with the API and history.state.questionIndex.
    We call evaluateNonPersistableState() to manipulate state to ensure the UI, API and history stack are all aligned.
   */
  const isNotSuitableToPersist = _get(persistedState, 'consultationReducer.isLoading', false);
  const state = isNotSuitableToPersist ? evaluateNonPersistableState(persistedState) : persistedState;
  if (environment === 'production') {
    const middlewares = _compact([thunk, freeze]);
    return createStore(rootReducer, state, applyMiddleware(...middlewares));
  }
  const logger = createLogger();
  const middlewares = _compact([thunk, freeze, logger]);
  const composeEnhancers = composeWithDevTools({});
  return createStore(rootReducer, state, composeEnhancers(applyMiddleware(...middlewares)));
};
